import { render, staticRenderFns } from "./DadosExtrasDlg.vue?vue&type=template&id=2c9f4579"
import script from "./DadosExtrasDlg.vue?vue&type=script&lang=js"
export * from "./DadosExtrasDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports